<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Оформление заказа</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- Billing Details Start -->
		<section class="billing-detail py-40">
			<div class="container-fluid">
				<div class="row row-gap-4">
					<div class="col-xl-8">
						<form @submit.prevent="checkoutSend">
							<div class="title-row title-row-2 bg-white mb-16">
								<h5>Контактная информация</h5>
							</div>
							<div class="billing-wrapper p-24 bg-white br-10 mb-40">
								<div class="contact-form">
									<div class="row">
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="text" name="lname" id="lastName" class="form-control" placeholder="Фамилия" v-model="lastname" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<path
														d="M10.5 0C7.59223 0 5.22656 2.36566 5.22656 5.27344C5.22656 8.18121 7.59223 10.5469 10.5 10.5469C13.4078 10.5469 15.7734 8.18121 15.7734 5.27344C15.7734 2.36566 13.4078 0 10.5 0ZM10.5 9.375C8.2384 9.375 6.39844 7.53504 6.39844 5.27344C6.39844 3.01184 8.2384 1.17188 10.5 1.17188C12.7616 1.17188 14.6016 3.01184 14.6016 5.27344C14.6016 7.53504 12.7616 9.375 10.5 9.375Z"
														fill="#141516" />
													<path
														d="M17.0612  13.992C15.6174 12.5261 13.7035 11.7188 11.6719 11.7188H9.32812C7.29656 11.7188 5.38258 12.5261 3.93883 13.992C2.50215 15.4507 1.71094 17.3763 1.71094 19.4141C1.71094 19.7377 1.97328 20 2.29688 20H18.7031C19.0267 20 19.2891 19.7377 19.2891 19.4141C19.2891 17.3763 18.4979 15.4507 17.0612 13.992ZM2.90859 18.8281C3.20215 15.5045 5.96918 12.8906 9.32812 12.8906H11.6719C15.0308 12.8906 17.7979 15.5045 18.0914 18.8281H2.90859Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="text" name="name" id="name" class="form-control" placeholder="Имя" v-model="firstname" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<path
														d="M10.5 0C7.59223 0 5.22656 2.36566 5.22656 5.27344C5.22656 8.18121 7.59223 10.5469 10.5 10.5469C13.4078 10.5469 15.7734 8.18121 15.7734 5.27344C15.7734 2.36566 13.4078 0 10.5 0ZM10.5 9.375C8.2384 9.375 6.39844 7.53504 6.39844 5.27344C6.39844 3.01184 8.2384 1.17188 10.5 1.17188C12.7616 1.17188 14.6016 3.01184 14.6016 5.27344C14.6016 7.53504 12.7616 9.375 10.5 9.375Z"
														fill="#141516" />
													<path
														d="M17.0612  13.992C15.6174 12.5261 13.7035 11.7188 11.6719 11.7188H9.32812C7.29656 11.7188 5.38258 12.5261 3.93883 13.992C2.50215 15.4507 1.71094 17.3763 1.71094 19.4141C1.71094 19.7377 1.97328 20 2.29688 20H18.7031C19.0267 20 19.2891 19.7377 19.2891 19.4141C19.2891 17.3763 18.4979 15.4507 17.0612 13.992ZM2.90859 18.8281C3.20215 15.5045 5.96918 12.8906 9.32812 12.8906H11.6719C15.0308 12.8906 17.7979 15.5045 18.0914 18.8281H2.90859Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="email" name="email" id="e-mail" class="form-control" placeholder="Email" v-model="email" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<g clip-path="url(#clip0_7968_53870)">
														<path
															d="M18.7422 2.96875H2.25781C1.2866 2.96875 0.5 3.76023 0.5 4.72656V15.2734C0.5 16.2455 1.29238 17.0312 2.25781 17.0312H18.7422C19.7053 17.0312 20.5 16.2488 20.5 15.2734V4.72656C20.5 3.76195 19.7165 2.96875 18.7422 2.96875ZM18.496 4.14062C18.1369 4.49785 11.9564 10.6458 11.743 10.8581C11.4109 11.1901 10.9695 11.3729 10.5 11.3729C10.0305 11.3729 9.58906 11.1901 9.25594 10.857C9.11242 10.7142 3.00012 4.63414 2.50398 4.14062H18.496ZM1.67188 15.0349V4.96582L6.73586 10.0031L1.67188 15.0349ZM2.50473 15.8594L7.56672 10.8296L8.4284 11.6867C8.98176 12.2401 9.71746 12.5448 10.5 12.5448C11.2825 12.5448 12.0182 12.2401 12.5705 11.6878L13.4333 10.8296L18.4953 15.8594H2.50473ZM19.3281 15.0349L14.2641 10.0031L19.3281 4.96582V15.0349Z"
															fill="#141516" />
													</g>
													<defs>
														<clipPath id="clip0_7968_53870">
															<rect width="20" height="20" fill="white" transform="translate(0.5)" />
														</clipPath>
													</defs>
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="tel" name="phone" id="phoneNumber" class="form-control" placeholder="Телефон" v-model="phone" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path
														d="M16.2509 15.5304L15.8338 14.8339C15.0836 13.5971 14.0484 12.1776 12.6904 12.1776C12.4389 12.1776 12.1897 12.2282 11.9431 12.3307L11.2142 12.6432C11.1477 12.6708 11.083 12.7022 11.0145 12.7355C10.828 12.8262 10.6165 12.929 10.3989 12.929C9.86217 12.929 9.2403 12.2305 8.64811 10.9623C8.06692 9.71762 8.10399 9.06508 8.23741 8.73673C8.38462 8.37447 8.72695 8.21959 9.09471 8.08041C9.14585 8.06101 9.19204 8.04342 9.23696 8.02493L9.97501 7.71418C11.8978 6.9101 11.1825 4.10014 10.948 3.17889L10.7491 2.3868C10.579 1.734 10.1282 0 8.63277 0C8.35594 0 8.06061 0.064496 7.75527 0.191774C7.55492 0.271334 4.79792 1.39672 3.79909 3.37382C2.60532 5.72716 2.82605 8.88296 4.45451 12.7515C6.07079 16.625 8.16669 18.9942 10.684 19.7933C11.1158 19.9305 11.6038 19.9999 12.1346 19.9999H12.1349C13.8721 19.9999 15.587 19.2608 15.7262 19.1994C16.3251 18.9457 16.7123 18.5601 16.8768 18.0532C17.1557 17.1937 16.6878 16.2519 16.2509 15.5304ZM15.5897 17.6356C15.5514 17.7534 15.4185 17.8609 15.1948 17.9551C15.1911 17.9567 15.1866 17.9586 15.1828 17.9603C15.1673 17.9672 13.615 18.647 12.1345 18.6469C11.7428 18.6469 11.3926 18.5988 11.0935 18.5037C8.97266 17.8305 7.1592 15.72 5.70231 12.2286C4.23459 8.7416 4.00006 5.96837 5.0062 3.98495C5.78746 2.43858 8.23335 1.45761 8.25734 1.44823C8.26221 1.44625 8.26699 1.44435 8.27177 1.44237C8.41105 1.38391 8.53589 1.35306 8.63277 1.35306C8.9309 1.35306 9.20223 1.81545 9.43803 2.72173L9.63602 3.51048C10.0632 5.18828 9.99819 6.23772 9.45129 6.46647L8.71675 6.77587C8.68753 6.78796 8.65334 6.80068 8.61563 6.81502C8.20989 6.96864 7.36558 7.28814 6.98375 8.22735C6.63727 9.0796 6.7807 10.1615 7.42178 11.535C8.28521 13.3835 9.25897 14.2821 10.3987 14.2821C10.9277 14.2821 11.3523 14.0757 11.6059 13.9525C11.6526 13.9298 11.6944 13.909 11.7393 13.8904L12.4693 13.5774C12.5446 13.546 12.6169 13.5307 12.6903 13.5307C13.0417 13.5307 13.6717 13.8786 14.6749 15.5325L15.0918 16.2285C15.6055 17.0767 15.6461 17.4618 15.5897 17.6356Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-4">
											<div class="input-block mb-16">
												<input type="text" name="country" id="region" class="form-control" placeholder="Страна" v-model="country" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path
														d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
														fill="#141516" />
													<path
														d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-4">
											<div class="input-block mb-16">
												<input type="text" name="town" id="city" class="form-control" placeholder="Город / населенный пункт" v-model="city" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path
														d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
														fill="#141516" />
													<path
														d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-4">
											<div class="input-block mb-16">
												<input type="text" name="postal" id="zip" class="form-control" placeholder="Индекс" v-model="postalCode" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path
														d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
														fill="#141516" />
													<path
														d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-12">
											<div class="input-block mb-16">
												<input type="text" name="address" id="location" class="form-control" placeholder="Адрес" v-model="address" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path
														d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
														fill="#141516" />
													<path
														d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-12">
											<div class="input-block">
												<label for="textbox" class="fw-500 mb-16">Комментарий к заказу (опционально)</label>
												<textarea name="textarea" id="textbox" cols="8" rows="5" class="form-control" placeholder="Примечание о вашем заказе, например, особые примечания по доставке." v-model="comment"></textarea>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Shipping Method -->
							<div class="title-row title-row-2 bg-white mb-16">
								<h5>Способы доставки</h5>   
							</div>
							<div class="shipping-radio-container bg-white mb-40">
								<div class="plans">
									<label class="plan basic-plan" :for="'deliveryMethod_'+deliveryMethod.id" v-for="deliveryMethod in deliveryMethods" :key="deliveryMethod.id">
										<input type="radio" name="deliveryMethod" :id="'deliveryMethod_'+deliveryMethod.id" v-model="selectedDeliveryMethod" :value="deliveryMethod.id" required>
										<span class="plan-content">
											<img :src="deliveryMethod.icon" style="width: 100px;" alt="">
											<span class="plan-details">
												<span class="h6 fw-500 dark-black">{{deliveryMethod.name}}</span>
												<span class="light-gray d-block">{{deliveryMethod.duration}}</span>
											</span>
											<span class="fw-500 dark-black text-end" style="width: 150px;">{{number_format(deliveryMethod.price)}} тг</span>
										</span>
									</label>
								</div>
							</div>
							<!-- Shipping Method -->
							<!-- Payment Method -->
							<div class="title-row title-row-2 bg-white mb-16">
								<h5>Способы оплаты</h5>   
							</div>
							<div class="shipping-radio-container bg-white">
								<div class="plans">
									<label class="plan basic-plan" :for="'paymentMethod_'+paymentMethod.id" v-for="paymentMethod in paymentMethods" :key="paymentMethod.id">
										<input type="radio" name="paymentMethod" :id="'paymentMethod_'+paymentMethod.id" v-model="selectedPaymentMethod" :value="paymentMethod.id" required>
										<span class="plan-content content-2">
											<img :src="paymentMethod.icon" alt="">
											<span class="plan-details">
												<span class="h6 fw-500 dark-black">{{paymentMethod.name}}</span>
											</span>
										</span>
									</label>
								</div>
								<div v-if="selectedPaymentMethod == 'card'">
									<h5 class="mt-16 mb-24">Детали оплаты</h5>
									<div class="row">
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="number" name="lastName" id="cardNumber" class="form-control" placeholder="Номер карты" v-model="paymentDetails.cardNumber" required>
												<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
													xmlns:xlink="http://www.w3.org/1999/xlink">
													<rect width="20" height="20" fill="url(#pattern0_8194_6745)" />
													<defs>
														<pattern id="pattern0_8194_6745" patternContentUnits="objectBoundingBox" width="1" height="1">
															<use xlink:href="#image0_8194_6745" transform="scale(0.0416667)" />
														</pattern>
														<image id="image0_8194_6745" width="24" height="24"
															xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAOLAAADiwF1yxf7AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAANZJREFUSInt1L1NA0EQhuHnTshHRAXYKQU4c0wRroIUEiKcmIgu3AF/dkwLQEwHBHBny7KDncBYQABrCYl7pZVmRtpvZrTaj5a/QA/3aLDKdBrcoVuE+AIjzDMN3cE5SqgxyCS8yQB1iUpaKTcNqnIHwh9oG/yDBntb+SmOI37GGSbYj9pVDHUSeY0hxjiK2hSXXzV42Iif8IZrHEgW8IgiRAq84h0zvHyiQVzsf7PlT+ljVYoft4MGFZpCcr0lLuQzu0oyO9DFrfRguey6xg0OMw3c8gvWwIxMn9PVxawAAAAASUVORK5CYII=" />
													</defs>
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block mb-16">
												<input type="text" name="name" id="cardHolderName" class="form-control" placeholder="Имя и фамилия владельца карты" v-model="paymentDetails.cardHolderName" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<path
														d="M10.5 0C7.59223 0 5.22656 2.36566 5.22656 5.27344C5.22656 8.18121 7.59223 10.5469 10.5 10.5469C13.4078 10.5469 15.7734 8.18121 15.7734 5.27344C15.7734 2.36566 13.4078 0 10.5 0ZM10.5 9.375C8.2384 9.375 6.39844 7.53504 6.39844 5.27344C6.39844 3.01184 8.2384 1.17188 10.5 1.17188C12.7616 1.17188 14.6016 3.01184 14.6016 5.27344C14.6016 7.53504 12.7616 9.375 10.5 9.375Z"
														fill="#141516" />
													<path
														d="M17.0612  13.992C15.6174 12.5261 13.7035 11.7188 11.6719 11.7188H9.32812C7.29656 11.7188 5.38258 12.5261 3.93883 13.992C2.50215 15.4507 1.71094 17.3763 1.71094 19.4141C1.71094 19.7377 1.97328 20 2.29688 20H18.7031C19.0267 20 19.2891 19.7377 19.2891 19.4141C19.2891 17.3763 18.4979 15.4507 17.0612 13.992ZM2.90859 18.8281C3.20215 15.5045 5.96918 12.8906 9.32812 12.8906H11.6719C15.0308 12.8906 17.7979 15.5045 18.0914 18.8281H2.90859Z"
														fill="#141516" />
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block">
												<input type="date" name="date" id="checkIn" class="form-control sel-input date_from" placeholder="Дата окончания действия карты" v-model="paymentDetails.expiryDate" required>
												<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<g clip-path="url(#clip0_7968_54156)">
														<path
															d="M6.34766 9.72656H5.09766C4.77406 9.72656 4.51172 9.98891 4.51172 10.3125C4.51172 10.6361 4.77406 10.8984 5.09766 10.8984H6.34766C6.67125 10.8984 6.93359 10.6361 6.93359 10.3125C6.93359 9.98891 6.67125 9.72656 6.34766 9.72656Z"
															fill="#141516" />
														<path
															d="M6.34766 12.2266H5.09766C4.77406 12.2266 4.51172 12.4889 4.51172 12.8125C4.51172 13.1361 4.77406 13.3984 5.09766 13.3984H6.34766C6.67125 13.3984 6.93359 13.1361 6.93359 12.8125C6.93359 12.4889 6.67125 12.2266 6.34766 12.2266Z"
															fill="#141516" />
														<path
															d="M6.34766 14.7266H5.09766C4.77406 14.7266 4.51172 14.9889 4.51172 15.3125C4.51172 15.6361 4.77406 15.8984 5.09766 15.8984H6.34766C6.67125 15.8984 6.93359 15.6361 6.93359 15.3125C6.93359 14.9889 6.67125 14.7266 6.34766 14.7266Z"
															fill="#141516" />
														<path
															d="M11.3477 9.72656H10.0977C9.77406 9.72656 9.51172 9.98891 9.51172 10.3125C9.51172 10.6361 9.77406 10.8984 10.0977 10.8984H11.3477C11.6713 10.8984 11.9336 10.6361 11.9336 10.3125C11.9336 9.98891 11.6713 9.72656 11.3477 9.72656Z"
															fill="#141516" />
														<path
															d="M11.3477 12.2266H10.0977C9.77406 12.2266 9.51172 12.4889 9.51172 12.8125C9.51172 13.1361 9.77406 13.3984 10.0977 13.3984H11.3477C11.6713 13.3984 11.9336 13.1361 11.9336 12.8125C11.9336 12.4889 11.6713 12.2266 11.3477 12.2266Z"
															fill="#141516" />
														<path
															d="M11.3477 14.7266H10.0977C9.77406 14.7266 9.51172 14.9889 9.51172 15.3125C9.51172 15.6361 9.77406 15.8984 10.0977 15.8984H11.3477C11.6713 15.8984 11.9336 15.6361 11.9336 15.3125C11.9336 14.9889 11.6713 14.7266 11.3477 14.7266Z"
															fill="#141516" />
														<path
															d="M16.3477 9.72656H15.0977C14.7741 9.72656 14.5117 9.98891 14.5117 10.3125C14.5117 10.6361 14.7741 10.8984 15.0977 10.8984H16.3477C16.6713 10.8984 16.9336 10.6361 16.9336 10.3125C16.9336 9.98891 16.6713 9.72656 16.3477 9.72656Z"
															fill="#141516" />
														<path
															d="M16.3477 12.2266H15.0977C14.7741 12.2266 14.5117 12.4889 14.5117 12.8125C14.5117 13.1361 14.7741 13.3984 15.0977 13.3984H16.3477C16.6713 13.3984 16.9336 13.1361 16.9336 12.8125C16.9336 12.4889 16.6713 12.2266 16.3477 12.2266Z"
															fill="#141516" />
														<path
															d="M16.3477 14.7266H15.0977C14.7741 14.7266 14.5117 14.9889 14.5117 15.3125C14.5117 15.6361 14.7741 15.8984 15.0977 15.8984H16.3477C16.6713 15.8984 16.9336 15.6361 16.9336 15.3125C16.9336 14.9889 16.6713 14.7266 16.3477 14.7266Z"
															fill="#141516" />
														<path
															d="M18.9648 2.53906H17.5586V1.5625C17.5586 1.23891 17.2962 0.976562 16.9727 0.976562C16.6491 0.976562 16.3867 1.23891 16.3867 1.5625V2.53906H11.3086V1.5625C11.3086 1.23891 11.0463 0.976562 10.7227 0.976562C10.3991 0.976562 10.1367 1.23891 10.1367 1.5625V2.53906H5.05859V1.5625C5.05859 1.23891 4.79625 0.976562 4.47266 0.976562C4.14906 0.976562 3.88672 1.23891 3.88672 1.5625V2.53906H2.48047C1.51121 2.53906 0.722656 3.32762 0.722656 4.29688V17.2656C0.722656 18.2349 1.51121 19.0234 2.48047 19.0234H18.9648C19.9341 19.0234 20.7227 18.2349 20.7227 17.2656C20.7227 16.8874 20.7227 4.62598 20.7227 4.29688C20.7227 3.32762 19.9341 2.53906 18.9648 2.53906ZM1.89453 4.29688C1.89453 3.97379 2.15738 3.71094 2.48047 3.71094H3.88672V4.6875C3.88672 5.01109 4.14906 5.27344 4.47266 5.27344C4.79625 5.27344 5.05859 5.01109 5.05859 4.6875V3.71094H10.1367V4.6875C10.1367 5.01109 10.3991 5.27344 10.7227 5.27344C11.0463 5.27344 11.3086 5.01109 11.3086 4.6875V3.71094H16.3867V4.6875C16.3867 5.01109 16.6491 5.27344 16.9727 5.27344C17.2962 5.27344 17.5586 5.01109 17.5586 4.6875V3.71094H18.9648C19.2879 3.71094 19.5508 3.97379 19.5508 4.29688V6.60156H1.89453V4.29688ZM18.9648 17.8516H2.48047C2.15738 17.8516 1.89453 17.5887 1.89453 17.2656V7.77344H19.5508V17.2656C19.5508 17.5887 19.2879 17.8516 18.9648 17.8516Z"
															fill="#141516" />
													</g>
													<defs>
														<clipPath id="clip0_7968_54156">
															<rect width="20" height="20" fill="white" transform="translate(0.5)" />
														</clipPath>
													</defs>
												</svg>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-block">
												<input type="number" name="cvv" id="cvvCode" class="form-control" placeholder="CVV код" v-model="paymentDetails.cvv" required>
												<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
													xmlns:xlink="http://www.w3.org/1999/xlink">
													<rect width="20" height="20" fill="url(#pattern0_8194_6746)" />
													<defs>
														<pattern id="pattern0_8194_6746" patternContentUnits="objectBoundingBox" width="1" height="1">
															<use xlink:href="#image0_8194_6746" transform="scale(0.0416667)" />
														</pattern>
														<image id="image0_8194_6746" width="24" height="24"
															xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFFSURBVEiJ7dU7L4RBFMbx37uIFRqVawiFIBFfQESpoUOrUaiQUJKgkahFKfEVXBqFRiNUQnQUSNRConEp3llZu+uSGI14qjPnzPyfnDPz5uVfXyhBOxbQFJl9jaUExzjDdmSDIXTCExojwwXmUzkymMR9ZIMaZMrDohePkQ2yueAFdZHhAvMl8wvgd/rMoAy1qAjrbF4tF1dKn3qOVaGESo1oGQ+hto4G3AZwNsT12MREODOP1TxGXThfZDCCC3QXmJ5gFGM4DblxHIYuLjD4HYM1LJbodA472MVsyFXjDtO4kY71S4MZ7CueZ730KT+GOKeNkFsp2P+hQRUOcIk9TOXVtrFVABoIjK7vGpC22i+9j568fCtaCvYm6FOsTw1i6O1De/b+cmKpDM8JjnCueLY/1TA6ErRJfzjNkQ2usBSZ+Rf1Cta3QY6cqXP9AAAAAElFTkSuQmCC" />
													</defs>
												</svg>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Payment Method -->
							 
							<button type="submit" ref="submit" style="display: none;"></button>
						</form>
					</div>
					<div class="col-xl-4">
						<div class="title-row title-row-2 mb-16">
							<h5>Детали заказа</h5>
						</div>
						<div class="summary-container bg-white">
							<div class="mb-16" v-for="product in appModel.checkoutProducts" :key="product.id">
								<div class="item-container mb-16">
									<div class="left-box d-flex align-items-center gap-16">
										<div class="icon-box">
											<img :src="product.poster" style="height: 65px;" alt="">
										</div>
										<router-link :to="{path: '/catalog/'+product.id}" class="h6">{{product.name}} x {{product.count}}</router-link>
									</div>
									<div class="right-box">
										<h6 class="light-gray">{{number_format(product.price)}} тг</h6>
									</div>
								</div>
								<div class="hr-line"></div>
							</div>
							
							<form @submit.prevent="checkCoupon">
								<div class="input-block d-flex justify-content-between pb-4">
									<input type="text" name="cp-Code" class="form-control" id="codeCp" placeholder="Код купона" v-model="couponCode">
									<button type="button" class="cus-btn">Применить</button>
								</div>
							</form>

							<div class="d-flex align-items-center justify-content-between mb-16">
								<h6>Сумма</h6>
								<h6 class="light-gray">{{number_format(productsPriceSum)}} тг</h6>
							</div>
							<div class="hr-line mb-16"></div>
							<div class="d-flex align-items-center justify-content-between mb-16">
								<h6>Доставка</h6>
								<h6 class="light-gray">{{number_format(deliveryPrice)}} тг</h6>
							</div>
							<div v-if="appModel.appliedCoupon.discount">
								<div class="hr-line mb-16"></div>
								<div class="d-flex align-items-center justify-content-between mb-16">
									<h6>Скидка по купону<br/>{{appModel.appliedCoupon.code}}</h6>
									<h6 class="light-gray">-{{number_format(appModel.appliedCoupon.discount)}} тг</h6>
								</div>
							</div>
							<div class="hr-line mb-16"></div>
							<div class="d-flex align-items-center justify-content-between mb-16">
								<h5 class="color-primary">ИТОГО</h5>
								<h5 class="color-primary">{{number_format(totalPrice)}} тг</h5>
							</div>
							<div class="hr-line mb-16"></div>
							<p class="light-gray mb-16">
								Ваши персональные данные будут использоваться для обработки вашего заказа, а также поддержки вашего взаимодействия с данным веб-сайтом.
							</p>
							<button type="button" @click="$refs.submit.click()" class="cus-btn active-btn">ОФОРМИТЬ ЗАКАЗ</button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Billing Details End -->

		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		couponCode: '',
		
		firstname: '',
		lastname: '',
		email: '',
		phone: '',
		country: '',
		city: '',
		postalCode: '',
		address: '',
		comment: '',
		
		selectedPaymentMethod: 'card',
		selectedDeliveryMethod: 'qazpost',
		
		paymentDetails: {
			cardNumber: '',
			cardHolderName: '',
			expiryDate: '',
			cvv: '',
		},
		
		deliveryMethods: [
			{
				id: 'qazpost',
				name: 'QazPost',
				price: 1000,
				duration: 'Доставка завтра',
				icon: '/assets/media/icons/shipping-icon-1.png',
			},
			{
				id: 'dhl',
				name: 'DHL',
				price: 2000,
				duration: 'Доставка сегодня',
				icon: '/assets/media/icons/shipping-icon-3.png',
			},
		],
		paymentMethods: [
			{
				id: 'card',
				name: 'Платежной картой (Visa / MasterCard)',
				icon: '/assets/media/icons/payment-card-1.png',
			},
			{
				id: 'cash',
				name: 'Наличными при получении',
				icon: '/assets/media/icons/payment-card-4.png',
			},
		],
	}),
	computed: {
		productsPriceSum(){
			return this.appModel.checkoutProducts.reduce((sum, product) => sum + (product.price * product.count), 0);
		},
		deliveryPrice(){
			return this.deliveryMethods.find(method => method.id === this.selectedDeliveryMethod).price;
		},
		totalPrice(){
			let discount = this.appModel.appliedCoupon.discount;
			if(this.productsPriceSum < discount){
				discount = this.productsPriceSum;
			}
			return (this.productsPriceSum - discount) + this.deliveryPrice;
		},
	},
	methods: {
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		onInitForm(){
			this.firstname = this.authModel.userProfile?.firstname||'';
			this.lastname = this.authModel.userProfile?.lastname||'';
			this.email = this.authModel.userProfile?.email||'';
			this.phone = this.authModel.userProfile?.phone||'';
			this.country = this.authModel.userProfile?.country||'';
			this.city = this.authModel.userProfile?.city||'';
			this.postalCode = this.authModel.userProfile?.postalCode||'';
			this.address = this.authModel.userProfile?.address||'';
			this.comment = '';
		},
		checkCoupon(){
			if(this.couponCode.length <= 0){
				alert('Введите код купона');
				return false;
			}
			this.appModel.checkCoupon(this.couponCode);
			this.couponCode = '';
		},
		checkoutSend(){
			this.$router.push({path: '/checkout/success'});
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.onInitForm();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		
		this.onInitForm();
		
		next();
	},
	components: {
		Benefits,
	},
};
</script>